export default {
	methods: 
    {
		// notificacion al guardar
		async saveNotify(error,title=false,content=false,color=false)
		{
			try{				
				await this.changeGlobal({ state: 'saveConfig/notification/error', boolean: error})
				if(error) {
					await this.updateGlobal({ state: 'saveConfig/notification/title', data: 'No se guardaron los datos, intentalo de nuevo'})
				}
				if(content!==false) {
					await this.updateGlobal({ state: 'saveConfig/notification/content', data: content})
				}
				if(title!==false) {
					await this.updateGlobal({ state: 'saveConfig/notification/title', data: title})
				}
				const await1 =  this.updateGlobal({ state: 'saveConfig/notification/color', data: color})
				const await2 =  this.changeGlobal({ state: 'saveConfig/notification/view',  boolean: true})
				await await1
				await await2
				return !error
			}catch {

			}
		},
		// guardamos información en el backend
		async save(agregar=false,savePost=false) {
			if(typeof agregar === 'boolean')
			{
				if(savePost===false)
				{
					( async () => { 
						const dataForm = {}
						if(this.dataPost[this.namePath].tablaPost.length>0)
						{
							for (let i = 0; i < this.dataPost[this.namePath].tablaPost.length; i++) {								
								if(this.dataForm[this.namePath][this.dataPost[this.namePath].tablaPost[i]].length===undefined ||this.dataForm[this.namePath][this.dataPost[this.namePath].tablaPost[i]].length>0)
								{
									dataForm[this.dataPost[this.namePath].tablaPost[i]]={}
									if(this.dataForm[this.namePath][this.dataPost[this.namePath].tablaPost[i]]!==undefined)
									{
										if(this.dataForm[this.namePath][this.dataPost[this.namePath].tablaPost[i]].id!==undefined && this.dataForm[this.namePath][this.dataPost[this.namePath].tablaPost[i]].id!==null && this.dataForm[this.namePath][this.dataPost[this.namePath].tablaPost[i]].id!=='' && this.user.admin!==1  && this.namePath!=='afiliacion_nueva')
										{
											let keysTablas=Object.keys(this.dataForm[this.namePath][this.dataPost[this.namePath].tablaPost[i]])
											for (let k = 0; k < keysTablas.length; k++) {
												let idTablaCampos=this.predeterminados.configuracion.tabla_campos.findIndex(list => { return list.tabla===this.dataPost[this.namePath].tablaPost[i] && list.campo===keysTablas[k] && list.autorizar=== 1})
												if(idTablaCampos===-1)
												{
													dataForm[this.dataPost[this.namePath].tablaPost[i]] [keysTablas[k]]=this.dataForm[this.namePath][this.dataPost[this.namePath].tablaPost[i]] [keysTablas[k]]
												}	
												else
												{											
													if(dataForm['autorizar']===undefined)
													{
														dataForm['autorizar']=[]
													}
													let cambios= {}
													if( dataForm[this.dataPost[this.namePath].tablaPost[i]].id_datos_afiliado!==undefined)
													{														
														cambios.datos_afiliado= {id: dataForm[this.dataPost[this.namePath].tablaPost[i]].id_datos_afiliado}
													}
													cambios[this.dataPost[this.namePath].tablaPost[i]] = {}
													cambios[this.dataPost[this.namePath].tablaPost[i]]['id']=dataForm[this.dataPost[this.namePath].tablaPost[i]].id
													cambios[this.dataPost[this.namePath].tablaPost[i]][keysTablas[k]]=this.dataForm[this.namePath][this.dataPost[this.namePath].tablaPost[i]] [keysTablas[k]]

													let name=''
													let nota=''
													if(this.predeterminados.configuracion.tabla_campos[idTablaCampos].list!==null)
													{
														name=this.gettersDatalist(this.predeterminados.configuracion.tabla_campos[idTablaCampos].list,this.dataForm[this.namePath][this.dataPost[this.namePath].tablaPost[i]] [keysTablas[k]])
														name=name[0].name
														nota='Cambiar '+this.predeterminados.configuracion.tabla_campos[idTablaCampos].name+' por '+name
													}
													else 
													{
														nota='Cambiar '+this.predeterminados.configuracion.tabla_campos[idTablaCampos].name+' por '+this.dataForm[this.namePath][this.dataPost[this.namePath].tablaPost[i]] [keysTablas[k]]
													}												
													
													dataForm['autorizar'].push({id: null,name_path: this.namePath,eliminar: 0, cambios: cambios, nota: nota, tabla_delete: null})										
												}								
											}

										}									
										else {
											dataForm[this.dataPost[this.namePath].tablaPost[i]]=this.dataForm[this.namePath][this.dataPost[this.namePath].tablaPost[i]]											
										}
										
									}	
								}					
							}
							await this.pushDataPost({state: 'data', data: dataForm})
						}
						///estoy buscando el autofocus en el seach de dataPost
						await this.changeGlobal({state: 'saveConfig/autofocus', boolean: true})
					})()
				}				
				if(!agregar)
				{					
					await this.changeGlobal({state: 'saveConfig/capa', boolean: true})
					if(this.produccion===false)
					{
						let promiseValues = await new Promise(async (resolve, reject) => {	

							//   enviamos datos al backend  
							let promiseValue =  await this.saveAll(this.dataPost[this.namePath]).then( async (response) => {
								// aca lanzamos la notificacion y revisamos si hubo error o no y resolvemos		          
								this.saveNotify(response.data.error,'Datos guardados con éxito',false,false)		          
								if(response.data.error===false)
								{   				
									await this.updateCrud({state: 'conection', data: {inicial:  this.fecha().beetween.inicial, final: this.fecha().beetween.final}})
									await this.saveIdb({ultima_conexion: {id: 1, inicial: this.fecha().beetween.inicial, final: this.fecha().beetween.final }})
									this.resetDataPost({state: 'data'}) 
									return response.data
								}
								return response.data.error						             
							}).catch(
							async (error) => {	 
								await this.changeGlobal({state: 'saveConfig/capa', boolean: false}) 
								this.saveNotify(true)	  	  
							//   aca manipulamos los datos del store despues del error   
							return error
							});	
							resolve(promiseValue)	         	
						});
						return promiseValues
					}
					else
					{						
						for (let i = 0; i < this.dataPost[this.namePath].data.length; i++) {	
							await this.saveIdb(this.dataPost[this.namePath].data[i])
						}						

						for (let i = 0; i < this.dataPost[this.namePath].tablaDelete.length; i++) {											
							await this.deleteIdb({tabla: this.dataPost[this.namePath].tablaDelete[i], id: this.dataForm[this.namePath][this.dataPost[this.namePath].tablaDelete[i]].id })						
						}
						
						const await1 = this.saveNotify(false)							
						const await2 = this.resetDataPost({state: 'data'}) 
						const await3 = this.resetGlobal({state: 'saveConfig/capa'}) 
						const await4 = this.resetGlobal({state: 'saveConfig/popoverShow'}) 
						await await1
						await await2
						await await3
						await await4
						return true
					}					
				}
				else{	
					( async () => { 
						await this.resetDataIndex() 
					})()					
					return true
				}		
			}
			else{
				this.saveNotify(true,'No puedes modificar el javascript de la aplicación')
			}			 
		},
	},
}